import authStore from "./auth";
import pageStore from "./page";
import usersStore from "./users";

const models = {
  auth: authStore,
  page: pageStore,
  users: usersStore,
};

export default models;
